import {Route, Routes} from 'react-router-dom';
import Panel from './components/Panel.jsx';
import PagesOurTeam from './components/PagesOurTeam.jsx';
import PagesBlog from './components/PagesBlog.jsx';
import './static/css/_fonts.css';
import './static/css/_icon.css';
import MrbgSessionDetail from './components/mrbg/MrbgSessionDetail.jsx'

function App(){

  return (
    <Routes>
      <Route path="/login" element={<Panel/>}/>
      <Route path="/panel/:id" element={<MrbgSessionDetail/>} />
      <Route path="/panel" element={<Panel/>}/>
      <Route path="/otm/:otID/:member" element={<PagesOurTeam/>}/>
      <Route path="*" element={<PagesBlog/>}/>
    </Routes>
  )
}

export default App;
